<template>
  <div class="select">
    <div style="margin-right: 10px">
      <span>{{$t("headSearch.plat")}}: </span>
      <el-select v-model="plat"
                 size="small"
                 style="width: 120px"
                 @change="changePlat">
        <el-option v-for="(item,index) in platList"
                   :key="index"
                   :label='item.label'
                   :value='item.value'>
        </el-option>
      </el-select>
    </div>
    <zTree style="margin-right: 10px"
           :width="180"
           :height="300"
           :checkedKeys="defaultCheckedKeys"
           v-model="selectIds"
           :treeDomId="'topTree'"
           :multiple="true"
           :size="'small'"
           :treeDomSearchId="'topSearchId'"
           :plat="plat"
           @ChildrenListLoaded="childrenListLoaded"
           @ChangeAllPlat="changeAllPlat"
           @ChangeJdPlat="changeJdPlat"
           :type="treeType"
           ref="catSelectTree"></zTree>
    <el-input :placeholder="$t('topHead.select_option_concept_holder')"
              class="wordBox"
              style="height: 32px"
              v-model="keyWards"
              size="small">
      <el-button slot="append"
                 @click.stop="searchKeyWards"
                 icon="el-icon-search"></el-button>
    </el-input>

    <el-tooltip class="item"
                effect="dark"
                placement="bottom">
      <div slot="content">
        <div style="width:200px;text-align:center;">
          <p>{{$t('topHead.search_tooltip1')}}</p>
          <p>{{$t('topHead.search_tooltip2')}}</p>
          <p>{{$t('topHead.search_tooltip3')}}</p>
          <p>{{$t('topHead.search_tooltip4')}}</p>
        </div>
      </div>
      <i class="iconfont icon-Hint"
         style="color:#bfbfbf;"></i>
    </el-tooltip>
  </div>
</template>


<script>
import zTree from '@/components/zTree.vue'
import { getWordTs, getJdWordTs } from '@/api/public'
import { getWordTs as getAmazonWordTs } from '@/api/amazon'
import { DateTime } from 'luxon'
import { getObjFromUrl, changePlatList } from '@/utils'

export default {
  name: 'TopSearch',
  components: { zTree },
  data() {
    return {
      keyWards: this.$store.state.user.selectedKeyWards,
      selectIds: [],
      plat: 'all',
      platList: [],
      defaultCheckedKeys: [],
      cid: '',
      ts: '',
      treeType: 'default',
      isSocialDetail: false,
    }
  },
  computed: {
    amazonLoginCatList() {
      return this.$store.state.user.amazonLoginCatList
    },
  },
  methods: {
    searchKeyWards() {
      if (this.selectIds.length == 0) {
        this.$message.error('类目不能为空!')
        return
      }
      if (this.keyWards != '') {
        let cid = ''
        if (!this.cid) {
          cid = null
        } else {
          cid = this.cid
        }
        this.getTs()
          .then((res) => {
            if (res.status == 'ok') {
              this.ts = res.result.ts
              if (this.plat == 'gamazon') {
                if (this.$store.state.user.amazonLoginCatlevel.length > 0) {
                  cid.split(',').forEach((id) => {
                    let item = this.$store.state.user.amazonLoginCatlevel.find(
                      (item) => item.cat_id == id
                    )
                    let _ts = DateTime.fromISO(item.ts).ts
                    if (_ts < DateTime.fromISO(this.ts).ts) {
                      this.ts = item.ts
                    }
                  })
                }

                this.$router.push({
                  name: 'publicDetail',
                  query: {
                    cid: cid,
                    word: this.keyWards.trim(),
                    publicTs: this.ts,
                    start: this.ts,
                    end: this.ts,
                    plat: this.plat,
                  },
                })
              } else {
                this.$router.push({
                  name: 'detail',
                  query: {
                    cid: cid,
                    word: this.keyWards.trim(),
                    ts: this.ts,
                    start: this.ts,
                    end: this.ts,
                    plat: this.plat,
                  },
                })
              }
            }
          })
          .catch((e) => {
            this.$message.error(e.backMsg)
          })
        this.$store.dispatch(
          'user/changeSelectedKeyWards',
          this.keyWards.trim()
        )
        this.$store.dispatch('user/changeActivedTab', 'TrendList')
        this.$store.dispatch('user/changeBrandId', null)
        this.$store.dispatch('user/changeBrandName', null)
        this.$store.dispatch('user/changeActivedTabArr', [])
        localStorage.setItem('passActivedTab', 'TrendList')
        localStorage.setItem('word', this.keyWards.trim())
      } else {
        this.$message.warning(this.$t('mainHead.rules_message_search'))
        this.keyWards = this.$store.state.user.selectedKeyWards.replace(
          new RegExp('&amp;', 'g'),
          '&'
        )
      }
    },
    getTs() {
      let getWordTsMethod = getWordTs
      if (this.plat == 'jd') {
        getWordTsMethod = getJdWordTs
      } else if (this.plat == 'gamazon') {
        getWordTsMethod = getAmazonWordTs
      }
      return getWordTsMethod()
    },
    changePlat(val) {
      let loginCatlevel
      if (val == 'jd') {
        loginCatlevel = this.$store.state.user.jdLoginCatlevel
      } else if (val == 'gamazon') {
        loginCatlevel = this.$store.state.user.amazonLoginCatlevel
      } else {
        loginCatlevel = this.$store.state.user.loginCatlevel
      }
      const { is_validata_user_count } = this.$store.state.user.loginInfo
      switch (val) {
        case 'jd':
          if (typeof loginCatlevel != 'string' && loginCatlevel.length > 0) {
            this.defaultCheckedKeys = []
          } else if (loginCatlevel == 'all' || is_validata_user_count) {
            this.defaultCheckedKeys = ['1316']
          }
          break
        case 'gamazon':
          if (typeof loginCatlevel != 'string' && loginCatlevel.length > 0) {
            this.defaultCheckedKeys = []
          } else if (loginCatlevel == 'all' || is_validata_user_count) {
            this.defaultCheckedKeys = ['1064954']
          }
          break
        default:
          this.defaultCheckedKeys = []
          break
      }
      const query = getObjFromUrl(window.location.hash)
      if (query.word1) {
        this.plat = 'jd'
        setTimeout(() => {
          this.plat = 'all'
        }, 20)
        let platParams = {
          all: 'all',
        }
        this.platList = changePlatList(platParams)
      }
    },
    changeJdPlat() {
      const jdCatList = this.$store.state.user.loginInfo.jd_cat_list
      const douyinCatList = this.$store.state.user.loginInfo.douyin_cat_list
      const jdArr = Object.keys(jdCatList).map((key) => jdCatList[key])
      const douyinArr = Object.keys(douyinCatList).map(
        (key) => douyinCatList[key]
      )
      let isJd = []
      let isDouyin = []
      jdArr.forEach((item) => {
        if (item.length > 0) {
          isJd.push(item)
        }
      })
      douyinArr.forEach((item) => {
        if (item.length > 0) {
          isDouyin.push(item)
        }
      })
      if (isJd.length > 0) {
        if (isDouyin.length > 0) {
          if (this.$route.query.plat == 'douyin') {
            this.plat = 'douyin'
            this.changePlat('douyin')
          } else {
            this.plat = 'jd'
            this.changePlat('jd')
          }
          let platParams = {
            jd: 'jd',
            douyin: 'douyin',
          }
          this.platList = changePlatList(platParams)
        } else {
          this.plat = 'jd'
          this.changePlat('jd')
          let platParams = {
            jd: 'jd',
          }
          this.platList = changePlatList(platParams)
        }
      } else if (isDouyin.length > 0) {
        this.plat = 'douyin'
        this.changePlat('douyin')
        let platParams = {
          douyin: 'douyin',
        }
        this.platList = changePlatList(platParams)
      }

      const query = getObjFromUrl(window.location.hash)
      if (query.word1) {
        this.plat = 'jd'
        setTimeout(() => {
          this.plat = 'all'
        }, 20)
        let platParams = {
          all: 'all',
        }
        this.platList = changePlatList(platParams)
      }
    },
    childrenListLoaded(list) {
      const routeQuery = getObjFromUrl(window.location.hash)
      if (routeQuery.plat && this.plat == routeQuery.plat) {
        let param_val = routeQuery
        const arr = []
        if (param_val.cid != undefined && param_val.cid != '') {
          localStorage.setItem('cid', decodeURIComponent(param_val.cid))
          if (this.$refs.catSelectTree) {
            if (list[param_val.cid] && !list[param_val.cid].is_parent) {
              arr.push(1)
            }
          }
        }
        if (param_val.bid != undefined && param_val.bid != '') {
          arr.push(2)
          this.$store.dispatch(
            'user/changeBrandId',
            decodeURIComponent(param_val.bid)
          )
        }
        if (param_val.plat == 'gamazon') {
          this.$store.dispatch('user/changePublicActivedTabArr', arr)
        } else {
          this.$store.dispatch('user/changeActivedTabArr', arr)
        }
      }
    },
    changeAllPlat() {
      const allCatList = this.$store.state.user.loginInfo.cat_list
      const douyinCatList = this.$store.state.user.loginInfo.douyin_cat_list
      const allArr = Object.keys(allCatList).map((key) => allCatList[key])
      const douyinArr = Object.keys(douyinCatList).map(
        (key) => douyinCatList[key]
      )
      let isAll = []
      let isDouyin = []
      allArr.forEach((item) => {
        if (item.length > 0) {
          isAll.push(item)
        }
      })
      douyinArr.forEach((item) => {
        if (item.length > 0) {
          isDouyin.push(item)
        }
      })
      if (this.plat == 'all') {
        this.plat = 'jd'
        if (isDouyin.length > 0) {
          setTimeout(() => {
            this.plat = 'all'
            this.changePlat('all')
            let platParams = {
              all: 'all',
              douyin: 'douyin',
              tbjddy: 'tbjddy',
            }
            this.platList = changePlatList(platParams)
          }, 10)
        } else {
          setTimeout(() => {
            this.plat = 'all'
            this.changePlat('all')
            let platParams = {
              all: 'all',
              tbjddy: 'tbjddy',
            }
            this.platList = changePlatList(platParams)
          }, 10)
        }
      } else if (isAll.length > 0) {
        if (isDouyin.length > 0) {
          if (this.$route.query.plat == 'douyin') {
            this.plat = 'douyin'
            this.changePlat('douyin')
          } else {
            this.plat = 'all'
            this.changePlat('all')
          }
          let platParams = {
            all: 'all',
            douyin: 'douyin',
            tbjddy: 'tbjddy',
          }
          this.platList = changePlatList(platParams)
        } else {
          this.plat = 'all'
          this.changePlat('all')
          let platParams = {
            all: 'all',
            tbjddy: 'tbjddy',
          }
          this.platList = changePlatList(platParams)
        }
      } else if (isDouyin.length > 0) {
        this.plat = 'douyin'
        this.changePlat('douyin')
        let platParams = {
          douyin: 'douyin',
        }
        this.platList = changePlatList(platParams)
      }
    },
    mulltipSelectRemoveTag() {},
    clearSelect() {},
  },
  created() {
    let platParams = {
      all: 'all',
      jd: 'jd',
      gamazon: 'gamazon',
      douyin: 'douyin',
      tbjddy: 'tbjddy',
    }
    this.platList = changePlatList(platParams)
    const query = getObjFromUrl(window.location.hash)
    for (const key in query) {
      query[key] = decodeURIComponent(query[key])
    }
    const path = this.$route.path
    if (path == '/concept') {
      this.treeType = 'search'
    } else {
      this.treeType = 'default'
    }
    if (query.cid) {
      this.cid = query.cid
      this.defaultCheckedKeys = this.cid.split(',')
    }
    if (query.ts) {
      this.ts = query.ts
    }
    if (query.plat) {
      this.plat = query.plat
    }
    if (query.word) {
      this.keyWards = query.word.replace(new RegExp('&amp;', 'g'), '&')
    }
  },
  mounted() {
    if (this.amazonLoginCatList) {
      if (
        this.amazonLoginCatList !== 'all' &&
        this.amazonLoginCatList.length == 0
      ) {
        this.platList.splice(2, 1)
      }
    }
  },
  watch: {
    '$route.query': {
      handler(val, oldVal) {
        const newVal = getObjFromUrl(window.location.hash)
        if (newVal.plat) {
          this.plat = newVal.plat
        }
        if (newVal.cid) {
          this.cid = newVal.cid
          this.defaultCheckedKeys = this.cid.split(',')
        }
        const arr = []
        if (newVal.cid != undefined && newVal.cid != '') {
          if (this.$refs.catSelectTree) {
            const childrenList =
              this.$refs.catSelectTree.catsData.result.childrenList
            if (
              childrenList[newVal.cid] &&
              !childrenList[newVal.cid].is_parent
            ) {
              arr.push(1)
            }
          }
        }
        if (newVal.bid != undefined && newVal.bid != '') {
          arr.push(2)
        }
        if (newVal.plat == 'gamazon') {
          this.$store.dispatch('user/changePublicActivedTabArr', arr)
        } else {
          this.$store.dispatch('user/changeActivedTabArr', arr)
        }
        const query = getObjFromUrl(window.location.hash)
        if (query.word1) {
          this.isSocialDetail = true
          let platParams = {
            all: 'all',
          }
          this.platList = changePlatList(platParams)
        } else {
          this.isSocialDetail = false
        }
      },
    },
    '$route.path': {
      handler(newVal, oldVal) {
        if (newVal == '/concept') {
          this.treeType = 'search'
        } else {
          this.treeType = 'default'
        }
      },
    },
    selectIds(newVal) {
      this.cid = newVal.join()
    },
    amazonLoginCatList(newVal) {
      if (newVal) {
        if (newVal !== 'all' && newVal.length == 0) {
          this.platList.splice(2, 1)
        }
      }
    },
    '$store.state.user.languageMode'(newVal) {
      let platParams = {
        all: 'all',
        jd: 'jd',
        gamazon: 'gamazon',
        douyin: 'douyin',
        tbjddy: 'tbjddy',
      }
      this.platList = changePlatList(platParams)
    },
  },
}
</script>

<style lang="less" >
.select {
  .wordBox {
    width: 230px;
  }
  .item {
    position: absolute;
    top: 0;
    right: 64px;
    line-height: 32px;
  }
}
</style>
